<template>
  <div class="form-search-date">
    <el-row>
      <div class="el-col">
        <el-row class="w-340">
          <div class="el-col">
            <label slot="label" class="el-form-item__label">
              {{ $t('profits.period_start') }}
            </label>
          </div>
          <el-col :span="24">
            <date-form @change-date="setStartDate" :date="periodStart" :yearPlaceHolder="this.$t('year')" :listYear="listYear"></date-form>
          </el-col>
        </el-row>
      </div>
      <div class="el-col range">
        〜
      </div>
      <div class="el-col w-340">
        <el-row>
          <el-col :span="24">
            <label slot="label" class="el-form-item__label">
              {{ $t('profits.period_end') }}
            </label>
          </el-col>
          <el-col :span="24">
            <date-form @change-date="setEndDate" :date="periodEnd" :yearPlaceHolder="this.$t('year')" :listYear="listYear"></date-form>
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>
<script>
  import { YEARS_START_FROM_2022 } from '../../constants'

  export default {
    emits: ['searchByDate'],

    data() {
      return {
        periodStart: {
          year: '',
          month: '',
          day: ''
        },
        periodEnd: {
          year: '',
          month: '',
          day: ''
        },
        data: {
          periodStart: '',
          periodEnd: ''
        },
        listYear: YEARS_START_FROM_2022
      }
    },

    methods: {
      search() {
        const data = {
          period_start: this.$dayjs(new Date(this.form.start.year, this.form.start.month - 1, this.form.start.day)).format('YYYY-MM-DD'),
          period_end: this.$dayjs(new Date(this.form.end.year, this.form.end.month - 1, this.form.end.day)).format('YYYY-MM-DD')
        };

        this.$emit('searchByDate', data)
      },

      setStartDate(data) {
        this.periodStart = data;

        if (!this.periodStart.month) {
          this.data.periodStart = this.$dayjs(`${this.periodStart.year}-01-01`).format('YYYY-MM-DD');
        } else if (!this.periodStart.day) {
          this.data.periodStart = this.$dayjs(`${this.periodStart.year}-${this.periodStart.month}-01`).format('YYYY-MM-DD');
        } else {
          this.data.periodStart = this.$dayjs(`${this.periodStart.year}-${this.periodStart.month}-${this.periodStart.day}`).format('YYYY-MM-DD');
        }

        this.$emit('searchByDate', this.data);
      },

      setEndDate(data) {
        this.periodEnd = data;

        if (!this.periodEnd.month) {
          this.data.periodEnd = this.$dayjs(`${this.periodEnd.year}-01-01`).format('YYYY-MM-DD');
        } else if (!this.periodEnd.day) {
          this.data.periodEnd = this.$dayjs(`${this.periodEnd.year}-${this.periodEnd.month}-01`).format('YYYY-MM-DD');
        } else {
          this.data.periodEnd = this.$dayjs(`${this.periodEnd.year}-${this.periodEnd.month}-${this.periodEnd.day}`).format('YYYY-MM-DD');
        }

        this.$emit('searchByDate', this.data);
      }
    },
  }
</script>

<style lang="scss" scoped>
  .form-search-date {
    margin-top: 16px;
  }
</style>
